import { Loading, Text } from 'components'
import { Box, Flex } from 'theme-ui'
import { noop } from 'utils'

interface ResultsTrayProps {
  ItemCard: ({
    item,
    onClick,
  }: {
    item: any
    onClick: () => void
  }) => JSX.Element
  variant: 'search' | 'select'
  results?: ({ id: string } & any)[]
  show?: boolean
  isLoading?: boolean
  LoadingComponent?: JSX.Element
  noResultsText?: string
  onSearchItemClick?: (item: any) => void
}

export function ResultsTray({
  ItemCard,
  show = false,
  results,
  variant,
  isLoading = false,
  LoadingComponent = <Loading />,
  noResultsText = 'No results found.',
  onSearchItemClick = noop,
}: ResultsTrayProps) {
  const SearchContents =
    results && results.length ? (
      results.map((item) => (
        <ItemCard
          key={item.id}
          onClick={() => onSearchItemClick(item)}
          item={item}
        />
      ))
    ) : (
      <Box sx={{ p: 4, margin: 'auto' }}>
        <Text variant="text.basic">{noResultsText}</Text>
      </Box>
    )

  return (
    <Box
      variant="layout.resultsTray.container"
      sx={{
        pointerEvents: show ? 'auto' : 'none',
      }}>
      <Flex
        variant={`layout.resultsTray.${variant}`}
        style={{
          transform: show ? 'scaley(1)' : 'scaley(0.5)',
          opacity: show ? 1 : 0,
          visibility: show ? 'visible' : 'hidden',
        }}
        data-cy="result-container"
        data-testid="result-container">
        {isLoading ? (
          <Box sx={{ p: 4, margin: 'auto' }}>{LoadingComponent}</Box>
        ) : (
          SearchContents
        )}
      </Flex>
    </Box>
  )
}
